import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Col, message, Radio, Row, Skeleton } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import moment from "moment-jalaali";
import {
  createTicketService,
  getSupportCategoriesService,
} from "./support.api";

function SupportTicket(props) {
  const { opened, handleCreateTicket } = props;

  const history = useHistory();

  const [categories, setCategories] = useState({
    contents: [],
    loading: false,
  });

  useEffect(() => {
    if (opened) {
      setCategories({ ...categories, loading: true });
      getSupportCategoriesService()
        .then((res) => {
          if (
            res.hasOwnProperty("data") &&
            res.data.hasOwnProperty("content")
          ) {
            if (res.data.content.length)
              setCategories({
                ...categories,
                contents: res.data.content,
                loading: false,
              });
            else setCategories({ ...categories, contents: [], loading: false });
          }
        })
        .catch((err) => {
          setCategories({ ...categories, contents: undefined, loading: false });
        });
    }
    // eslint-disable-next-line
  }, [opened]);

  function goToCategoryChat(categoryId) {
    createTicketService({
      subject: moment().format("HH:mm"),
      content: moment().format("HH:mm"),
      priority: "REGULAR",
      categoryId: categoryId,
    })
      .then((resp) => {
        history.push(`/support/${resp.data.id}`);
      })
      .catch((err) => message.error("خطایی در دریافت اطلاعات"));
  }

  return (
    <div className="support-create-form">
      <span className="title">
        لطفا از بین دسته بندی‌های ذیل، انتخاب بفرمایید:
      </span>
      <div className="categories">
        {categories.loading ? (
          <>
            <Skeleton active={true} paragraph={false} title></Skeleton>
            <Skeleton active={true} paragraph={false} title></Skeleton>
            <Skeleton active={true} paragraph={false} title></Skeleton>
          </>
        ) : categories.contents && categories.contents.length ? (
          <Radio.Group onChange={handleCreateTicket}>
            {categories.contents.map((category, i) => (
              <Radio
                key={i}
                className="category-item"
                value={category.id}
                onClick={() => goToCategoryChat(category.id)}
              >
                {category.title}
              </Radio>
            ))}
          </Radio.Group>
        ) : (
          <Row>
            <Col span={24}>
              <div className="center-flex empty">
                <InboxOutlined />
                لیست مورد نظر شما خالی است.
              </div>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
}

export default SupportTicket;
